import { type ReactNode, useRef } from 'react';
import { useElementWidth } from '../../../core/hooks';
import * as S from './styled';

export type ScaledStageProps = {
  designWidth: number;
  designHeight: number;
  allowUpscale?: boolean;
  className?: string;
  children?: ReactNode;
};

export const ScaledStage = ({
  designWidth,
  designHeight,
  allowUpscale = false,
  className,
  children,
}: ScaledStageProps) => {
  const frameRef = useRef<HTMLDivElement>(null);
  const frameWidth = useElementWidth(frameRef);
  const scale = allowUpscale ? frameWidth / designWidth : Math.min(1, frameWidth / designWidth);

  return (
    <S.Frame ref={frameRef} className={className} $scale={scale} $designHeight={designHeight}>
      <S.Stage $scale={scale} $designWidth={designWidth} $designHeight={designHeight}>
        {children}
      </S.Stage>
    </S.Frame>
  );
};
